import { useEffect, useState } from "react";
import { onSyncStatus, getSyncStatus, type SyncStatus } from "../lib/sync";

const MAP: Record<SyncStatus, { c: string; t: string }> = {
  live: { c: "var(--ok)", t: "Live" },
  syncing: { c: "var(--sky)", t: "Syncing…" },
  offline: { c: "var(--ink-3)", t: "Offline" },
  local: { c: "var(--warn)", t: "Local only" },
};

export function SyncBadge({ compact }: { compact?: boolean }) {
  const [s, setS] = useState<SyncStatus>(getSyncStatus());
  useEffect(() => onSyncStatus(setS), []);
  const m = MAP[s];
  return (
    <span className="row" title={`Data ${m.t}`} style={{ gap: 6, fontSize: 11.5, color: "var(--ink-2)" }}>
      <span style={{ width: 7, height: 7, borderRadius: 7, background: m.c, boxShadow: s === "live" ? `0 0 0 3px color-mix(in srgb, ${m.c} 22%, transparent)` : "none" }} />
      {!compact && m.t}
    </span>
  );
}
